import { Injectable, inject } from '@angular/core';
import { ToastComponent, ToastType } from '../components/Toast/toast.component';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toastComponent: ToastComponent | null = null;

  register(component: ToastComponent): void {
    this.toastComponent = component;
  }

  show(message: string, type: ToastType = 'info'): void {
    this.toastComponent?.show(message, type);
  }

  success(message: string): void { this.show(message, 'success'); }
  error(message: string): void { this.show(message, 'error'); }
  info(message: string): void { this.show(message, 'info'); }
  warning(message: string): void { this.show(message, 'warning'); }
}
